import * as  APIs from "../../apiCall/urls/registration"
import * as  APIStudent from "../../apiCall/urls/student"
import * as  APIMaster from "../../apiCall/urls/common"

import  {apiFunction} from "../../apiCall/function"
 
export const updateAadhar = (data) =>{
    return apiFunction(APIs.REGISTER_AADHAR, "post", data, false, null);
}

export const getMasterData = (data) =>{
    return apiFunction(APIMaster.MASTER, "post", data, false, null);
}

export const getDocMasterData = (data) =>{
    return apiFunction(APIMaster.MASTER_DOC, "post", data, false, null);
}
export const getDocMasterSchoolList = (data) =>{
    return apiFunction(APIMaster.MASTER_SCHOOL_LIST, "post", data, false, null);
}

export const getCustoDropdown = (data) =>{
    return apiFunction(APIMaster.CUSTOM_DROPDOWN, "post", data, false, null);
}

export const sendOTPForAadhar = (data) =>{
    return apiFunction(APIs.REGISTER_AADHAR_OTP, "post", data, false, null);
}

export const verifyOTPForAadhar = (data) =>{
    return apiFunction(APIs.VERIFY_AADHAR_OTP, "post", data, false, null);
}


export const uploadDoc = (data) =>{
    return apiFunction(APIMaster.UPLOAD_DOC, "post", data, true, "formData");
}

export const updateBasic = (data) =>{
    return apiFunction(APIs.REGISTER_BASIC, "post", data, true, null);
}

export const updateIncome = (data) =>{
    return apiFunction(APIs.REGISTER_INCOME, "post", data, true, null);
}

export const getStudentData = () =>{
    return apiFunction(APIStudent.GET_STUDENT, "get", null, true, null);
}

export const sendOtp = (data) =>{
    return apiFunction(APIs.SEND_OTP, "post", data, true, null);
}

export const getUserDetails = () =>{
    return apiFunction(APIStudent.GET_STUDENT_CRED, "get", null, true, null);
}

export const onFinalSubmit = () =>{
    return apiFunction(APIs.FINAL_SUBMIT, "post", null, true, null);
}

